import { render } from "./_InputCheckboxes.vue?vue&type=template&id=f2b142c4"
import script from "./_InputCheckboxes.vue?vue&type=script&lang=js"
export * from "./_InputCheckboxes.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/admin/Pieces/FormElements/_InputCheckboxes.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f2b142c4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f2b142c4', __exports__)) {
    api.reload('f2b142c4', __exports__)
  }
  
  module.hot.accept("./_InputCheckboxes.vue?vue&type=template&id=f2b142c4", () => {
    api.rerender('f2b142c4', render)
  })

}


export default __exports__